export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATE_TIME_FORMAT = 'H:mm DD/MM/YYYY'
